import smallLogo from '../../images/smallLogo.png';
import tgLittle from '../../images/tgLittle.png';
import inLittle from '../../images/inLittle.png';
import instLittle from '../../images/instLittle.png';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="footer" id='contactus'>
      <div className="footer__fix content-fix-index">
        <div className="footer__title">
          <div>{t('footerTitle', { returnObjects: true })[0]}<br/>{t('footerTitle', { returnObjects: true })[1]}<br/>{t('footerTitle', { returnObjects: true })[2]}</div>
        </div>

        <div className="footer__container">
          <img  className="footer__logo" alt='logo' src={smallLogo}/>

          <a href="https://t.me/nadiia_HR_bluff" className="footer__button_fix">
            <div className="footer__button">{t('footerButton')}</div>
          </a>

          <a href="https://t.me/nadiia_HR_bluff" className="footer__tg">
            <div>{t('footerTg')}</div>
          </a>

          <div className="footer__follow">
            <div className="footer__follow_text">{t('footerFollow')}</div>

            <a href="https://t.me/nadiia_HR_bluff"><img  className="footer__follow_icon" alt='icon' src={tgLittle}/></a>

            <a href="https://linkedin.com/company/bluff-corp"><img  className="footer__follow_icon" alt='icon' src={inLittle}/></a>

            <a href="https://instagram.com/bluff.corp/"><img  className="footer__follow_icon" alt='icon' src={instLittle}/></a>
          </div>

          <div className="footer_copyright">{t('footerCreator')}</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
